<template>
	<div>
		<div class="owl-carousel">
			<!-- <pre>{{items}}</pre> -->
			<template v-for='item in items'>
				<div class="item">
					<div class="row">
						<div class="cols s_24 m___16 l___24">
							<div class="header">{{item.header}}</div>
							<div class="text">{{item.text}}</div>

							<!-- <a :href='item.button1.href' :data-id='item.id' class="button1">{{item.button1.text}}</a> -->

							<a v-if="item.link" class="button1" :href="item.link.href">{{item.link.textButton}}</a>
							<!--<div v-if="item.button" class="button1" @click="sendId(item.button.popupFormID)">{{item.button.textButton}}</div>-->
							<a v-if="item.button"
								data-fancybox
								:data-src='`#${item.button.popupFormID}`'
								:href='`#${item.button.popupFormID}`'
								:data-key="item.button.key"
								@click="eventPopup(item.button.key)"
								class="button1">
								{{item.button.textButton}}
							</a>
						</div>
					</div>
				</div>
			</template>
		</div>

		<div class="row">
			<div class="cols s_24" style="overflow: auto">
				<ul class="grid s_5 m_3 m___5" :count='items ? items.length : 0'>
					<li v-for='item in items'>
						<a :href='item.button2.href' :data-id='item.id'>
							<span class="icon">
								<span :style='`background-image: url("${item.button2.icon}")`' class="one"></span>
								<span :style='`background-image: url("${item.button2["icon-hover"]}")`' class="two"></span>
							</span>

							<span class="text">{{item.button2.text}}</span>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

module.exports = {

	props: ['data'],

	data () {
		return {}
	},

	computed: {
		items() {
			return this.data ? this.data.items : [];
		}
	},

	methods: {
		eventPopup(ndata){
			// console.log(ndata);
			var event = new CustomEvent("sliderId", {
					detail: ndata
			});
			document.body.dispatchEvent(event);
		}
	},


	updated() {
		if($('.playVideo').length){
			if($('.playVideo').on('canplay')){
				this.$emit('updated', {
					owlSettings: {
						items: 1,
						loop: this.items.length > 1 ? true : false,
						// loop: false,
						// autoplayTimeout: 4300,
						nav: true,
						dots: false,
						autoplay: false,
						slideBy: 1,
						mouseDrag: false,
						touchDrag: $(window).width() > 641 ? false : true,
						onTranslate: () => {
							this.$parent.$el.classList.add('disabled');
						},
						onTranslated: () => {
							this.$parent.$el.classList.remove('disabled');
							// i++;
							// if(i == 4){
							// 	i = 0;
							// }
							// slide();
						},
						onInitialize: () => {
							$(document).trigger('play');
						}
					}
				});
			}
		}else{
			this.$emit('updated', {
				owlSettings: {
					items: 1,
					loop: this.items.length > 1 ? true : false,
					// loop: false,
					// autoplayTimeout: 4300,
					nav: true,
					dots: false,
					autoplay: false,
					slideBy: 1,
					mouseDrag: false,
					touchDrag: $(window).width() > 641 ? false : true,
					onTranslate: () => {
						this.$parent.$el.classList.add('disabled');
					},
					onTranslated: () => {
						this.$parent.$el.classList.remove('disabled');
						// i++;
						// if(i == 4){
						// 	i = 0;
						// }
						// slide();
					},
					onInitialize: () => {
						$(document).trigger('runSlider');
					}
				}
			});
		}
	},

	mounted(){
		$('[data-fancybox]').fancybox();
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {

	.slider-index-video {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 3;
		@include l_up {
			width: 970px;
			margin: 0 auto;
		};
		@include l___up{
			width: 1050px;
		};

		.owl-nav{
			opacity: 0;
			pointer-events: none;
		}
		.owl-carousel {
			margin-bottom: -50px;
			@include m_up{
				margin-bottom: 0px;
			}
			.item {
				background-color: transparent;
				padding: 54px 0 0;
				@include m___up {
					padding: 64px 0 0;
				};
				@include l__up {
					padding: 85px 0 0;
				};
				@include l___up {
					padding: 141px 0 0;
				};

				.header {
					font-family: $Circe_extrabold;
					color: #fff;
					font-size: 48px;
					line-height: 56px;
					margin: 0 0 15px;
					height: 168px;
					display: flex;
					align-items: center;
					@include m_up {
						font-size: 60px;
						line-height: 72px;
						height: 144px;
						margin: 0 0 22px;
					};
					@include l___up {
						font-size: 100px;
						line-height: 121px;
						height: 242px;
						margin: 0 0 41px;
					};
				}

				.text {
					font-family: $Circe_light;
					font-size: 18px;
					color: #fff;
					margin: 0 0 40px;
					height: 108px;
					display: flex;
					align-items: center;
					@include m_up {
						height: 54px;
					};
					@include l___up {
						font-size: 22px;
						height: 66px;
						padding: 0 350px 0 0;
						margin: 0 0 52px;
					};
				}

				a.button1 {
					display: inline-flex;
					height: 61px;
					align-items: center;
					border-radius: 30px;
					font-size: 18px;
					color: #fff;
					text-decoration: none;
					border: 2px solid #fff;
					padding: 0 35px;
					margin: 0 0 49px;
					@include single-transition;
					@include m_up {
						margin: 0 0 12px;
					};
					@include l___up {
						margin: 0 0 59px;
					};

					&:hover {
						border-color: #EAE500;
						color: #EAE500;
					}
				}
			}
		}

		ul.grid {
			padding-right: 15px;
			@media (max-width: 639px) {
				.icon{
					margin-bottom: 22px!important
				}
				@for $i from 1 through 10 {
					&[count='#{$i}'] {
						width: #{195 * $i + (15 * ($i - 1))}px;
						@if $i > 1 {
							margin: 0 15px 0 0;
						}
					}
				}
			}
			li:nth-last-child(1){
				a{

				}

			}
			li {

				a {
					display: flex;
					height: 82px;
					border: 2px solid #fff;
					color: #fff;
					text-decoration: none;
					font-size: 14px;
					border-radius: 7px;
					@include single-transition;
					@include m_up {
						height: 125px;
						flex-direction: column;
					};
					@include l___up {
						font-size: 16px;
					};

					&:hover, &.hover {
						border-color: #EAE500;

						.icon {

							span {
								display: block;
								&.two {
									opacity: 1;
								}
							}
						}

						.text {
							color: #EAE500;
						}
					}

					.icon {
						width: 77px;
						flex: 0 0 auto;
						display: block;
						margin-top: 22px;
						position: relative;
						margin-bottom: 10px;
						@include m_up {
							width: 100%;
							height: 45px;
						};

						span {
							display: block;
							height: 34px;
							background-size: contain;
							background-position: center;
							background-repeat: no-repeat;
							@include vam;
							// width: 40px;
							// height: 34px;
							@include single-transition;

							&.two {
								opacity: 0;
							}
						}
					}

					.text {
						font-family: $Circe_light;
						letter-spacing: 0.8px;
						flex: 1 1 auto;
						display: flex;
						align-items: center;
						@include single-transition;
						@include m_up {
							align-items: flex-start;
							justify-content: center;
						};
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// index-video.vue?5aefb010